export default [
    {
        name: 'cadastro-usuario-origem',
        path: 'usuario-origem',
        redirect: 'usuario-origem/index',
        component: () => import(/* webpackChunkName: 'cadastro-usuario-origem' */ '@/views/cadastro/usuario-origem/Index'),
        children: [
            {
                meta: {title: 'Lista de origens de usuário'},
                name: 'cadastro-usuario-origem-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-usuario-origem' */ '@/views/cadastro/usuario-origem/List.vue'),
            },
            {
                meta: {title: 'Cadastro de origem de usuário'},
                name: 'cadastro-usuario-origem-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-usuario-origem' */ '@/views/cadastro/usuario-origem/Form.vue'),
            },
            {
                meta: {title: 'Edição de origem de usuário'},
                name: 'cadastro-usuario-origem-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-usuario-origem' */ '@/views/cadastro/usuario-origem/Form.vue'),
            },
        ],
    },
]